// extracted by mini-css-extract-plugin
export default {"mainAssessmentsContainer":"Assessments_mainAssessmentsContainer__Z0bo+","assessmentsHeader":"Assessments_assessmentsHeader__+Vhvj"};